var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 464.805,
    height: 460,
    viewBox: "0 0 464.805 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(5115 -4900)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M228.4-484.4c-41.6,5-83,22.5-116,48.9A229.8,229.8,0,0,0,50-357.7c-8.3,17-12,26.8-16.5,44.2-5.6,21.2-7,33-6.9,58,0,22.8,1.1,33.2,5.5,52.5,5.3,22.9,17.8,51.9,30.9,72C106-65.4,178.4-26,256-26c77.9,0,149.8-39.1,193-105,7.5-11.5,19.8-36.2,24-48.5,8.9-25.7,12.4-47.4,12.4-76.5,0-24.6-1.4-36.5-7-58-24.2-92.7-104.2-161.4-199.3-171C265.4-486.3,242.1-486.1,228.4-484.4Zm55,43a188.815,188.815,0,0,1,77.7,30.2c43.8,29.5,73,76.6,80.5,129.9,2.4,17.3,1.5,46.4-2,62.8C423.2-140.4,361.4-82.1,282.9-70.6c-13.9,2.1-39.9,2.1-53.8,0-74.9-11-136.3-66-154.7-138.5-5.6-22.4-7.3-51.9-4-73.6,8-53,36.8-99,80.5-128.4A187.221,187.221,0,0,1,225.8-441C240-443.4,269.3-443.6,283.4-441.4Z",
    transform: "translate(-5135.595 5385.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M310.136-361a19.478,19.478,0,0,0-6.034,2.854c-1.468,1.223-23.646,30.088-49.25,64.253-25.6,34.083-46.722,62.215-46.885,62.459-.163.163-13.372-12.72-29.436-28.783-19.651-19.651-30.088-29.436-32.127-30.333-5.952-2.446-13.943-1.06-18.428,3.1-5.382,4.974-7.012,14.188-3.669,20.548,1.06,1.875,17.368,18.754,39.139,40.444,31.882,31.719,37.834,37.264,40.688,38.079,5.137,1.468,8.562,1.142,13.128-1.06,4-2.038,6.849-5.626,58.382-74.446,29.762-39.791,54.55-73.549,55.121-75.1C334.842-351.381,322.937-364.019,310.136-361Z",
    transform: "translate(-5112.076 5404.471)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 23.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    transform: "translate(-5115 4900)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 56
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 230,
    r: 230,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 230,
    r: 202,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1);
export default __webpack_public_path__ + "static/media/Group 1.d6b7cae7e0fa6ce2ce65633333fbcdd7.svg";
export { ForwardRef as ReactComponent };